// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How to interpret the register value.
 */
export enum ModbusInterpretation {
  /**
   * Whole register value (e.g. service code = register value).
   */
  WholeValue = 0,

  /**
   * Single bit within a register (bitmask).
   */
  BitmaskSingleBit = 1,
}
